import { AppState } from '../state/appState';
import { RequestStatusId, RequestStatusType } from '../state/requestStatusState';

export function isRequestPending(state: AppState, type: RequestStatusType, id: RequestStatusId): boolean {
	return state.requestStatus.requestsByType.get(type)?.requestsById.get(id) === 'pending';
}